import { createContext } from "react";

export interface TimeoutOptions {
  time: number; // in seconds
  message?: string;
}

export interface GlobalLoaderContextType {
  isVisible: boolean;
  show: (options?: { timeoutOptions?: TimeoutOptions }) => void;
  hide: () => void;
}

const GlobalLoaderContext = createContext<GlobalLoaderContextType | undefined>(undefined);

export default GlobalLoaderContext;
